import {Api} from "../../api/api";
import {metrica} from "../../metrica";
import {changeAmountCount} from "../cart";
import {changeCount} from "../changeCount/changeCount";

class AddCart {
  #rootElement;

  #api = new Api();

  constructor() {
    this.#rootElement = document.querySelector(".js-product-btn-wrap");

    if (!this.#rootElement) return;

    this.onDocumentClick = this.onDocumentClick.bind(this);

    document.addEventListener("click", this.onDocumentClick);
  }

  #sendAddCartEcommerce = (productInfo, category) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      ecommerce: {
        currencyCode: "RUB",
        add: {
          products: [
            {
              id: productInfo.id,
              name: productInfo.name,
              brand: productInfo.brand,
              category: category,
              price: productInfo.price.current,
              count: 1,
            },
          ],
        },
      },
    });

    console.log(window.dataLayer);
  };

  async #postData(button) {
    try {
      const addCartUrl = button.dataset.cartUrl;
      const productId = button.dataset.productId;
      const cartRes = await this.#api.customQuery(addCartUrl, {});
      const productRes = await this.#api.getProductInfo(productId);

      if (!cartRes || !productRes) return;

      const {countAll, countThis, category} = cartRes;
      const {code, answer} = productRes;

      if (countAll && countThis) {
        changeAmountCount(countAll);
        changeCount(this.#rootElement, false, false, countThis);
        this.#rootElement.setAttribute("data-in-cart", "");

        if (code === 200 && Boolean(answer.data)) {
          this.#sendAddCartEcommerce(answer.data, category);
        }

        metrica.sendMetric(`add-cart`);
      }
    } catch (error) {
      console.log(error);
    }
  }

  onDocumentClick({target}) {
    if (target.classList.contains("js-add-cart") || target.closest(".js-add-cart")) {
      const button = target.classList.contains("js-add-cart") ? target : target.closest(".js-add-cart");

      this.#postData(button);
    }
  }
}

export {AddCart};
